import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  interactive?: boolean;
  elevated?: boolean;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick,
  interactive = false,
  elevated = false,
}) => {
  const baseClasses = `
    bg-white dark:bg-dark-paper rounded-xl border border-gray-200/80 dark:border-gray-700 backdrop-blur-sm
    ${elevated ? 'shadow-md' : 'shadow-sm'}
    transition-all duration-300
    ${interactive ? 'cursor-pointer' : ''}
    ${className}
  `;

  if (interactive && onClick) {
    return (
      <motion.div
       role="button"
       tabIndex={0}
       onKeyDown={(e) => {
         if (e.key === 'Enter' || e.key === ' ') {
           e.preventDefault();
           onClick();
         }
       }}
        className={baseClasses}
        onClick={onClick}
        whileHover={{ 
          scale: 1.02, 
          boxShadow: '0 12px 28px rgba(0, 0, 0, 0.12)',
          borderColor: 'rgba(79, 70, 229, 0.3)'
        }}
        whileTap={{ scale: 0.99 }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      >
        {children}
      </motion.div>
    );
  }

  return <div className={baseClasses}>{children}</div>;
};

export default Card;